import { createFileRoute } from '@tanstack/react-router';
import Caps from 'src/pages/Organization/Reports/Caps';

export const Route = createFileRoute('/$organizationSlug/reports/caps/')({
  component: Caps,
});
